import React from 'react';
import { ExternalLink } from '../../../../../components';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useModal } from '../../../../../services/context/ModalProvider';
import ModalFormBox from '../../../../../newComponents/ContactModalForm';
import styled from 'styled-components';

const ContactSubmenu = () => {
    const { openModal, closeModal } = useModal();

    const handleOpenDefaultForm = e => {
        // supply the form as a React element
        e.preventDefault();
        openModal(<ModalFormBox closeBtn={() => closeModal()} subjectLine="" />);
    };
    return (
        <div className="submenu" onClick={e => e.stopPropagation()}>
            <ul>
                <li key="schedule">
                    <ExternalLink href="https://calendly.com/frankhajek/30min">
                        <FormattedMessage id="NewLandingPage.header.scheduleCall" />
                    </ExternalLink>
                </li>
                <li key="email">
                    <Link to="/" onClick={handleOpenDefaultForm}>
                        <FormattedMessage id="NewLandingPage.header.sendEmail" />
                    </Link>
                </li>
                <li key="teamup">
                    <Link to="/team-up">
                        <FormattedMessage id="NewLandingPage.header.teamUp" />
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default ContactSubmenu;
